// shared/components/empty-state.ts — <app-empty-state>

export class AppEmptyState extends HTMLElement {
  static define() { customElements.define('app-empty-state', AppEmptyState); }

  connectedCallback() {
    const icon    = this.getAttribute('icon') ?? '📭';
    const message = this.getAttribute('message') ?? 'Sin datos';
    const sub     = this.getAttribute('sub') ?? '';

    this.innerHTML = `
      <style>
        :host { display: flex; flex-direction: column; align-items: center;
                justify-content: center; padding: var(--space-10) var(--space-4);
                text-align: center; }
        .icon { font-size: 2.5rem; margin-bottom: var(--space-3); }
        .msg  { font-size: var(--text-sm); color: var(--color-text-muted); font-weight: var(--font-weight-medium); }
        .sub  { font-size: var(--text-xs); color: var(--color-text-subtle); margin-top: var(--space-1); }
      </style>
      <span class="icon">${icon}</span>
      <p class="msg">${message}</p>
      ${sub ? `<p class="sub">${sub}</p>` : ''}
    `;
  }
}
